import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as _ from "lodash";
import { ItemLibrary } from "app/infrastructure/model/classes/itemLibrary.class";
import {
  BusinessLogicService
} from "app/infrastructure/services/businessLogic.service";
import { BusinessLogic } from "app/infrastructure/model/interfaces/businessLogic.interface";
import { MarketplaceService, MARKETPLACE_ITEMTYPE_AllOfThem, MARKETPLACE_ITEMTYPE_BusinessLogic } from "app/infrastructure/services/marketplace.service";
import { Marketplace } from "app/infrastructure/model/classes/marketplace.class";

interface FilterItem {
  value: string;
  selected: boolean;
}

interface Filter {
  country: FilterItem[];
  type: FilterItem[];
  insurance: FilterItem[];
}

@Component({
  selector: "app-desktop",
  templateUrl: "./subscribe-business-logic.component.html",
  styleUrls: ['./subscribe-business-logic.component.scss']
})
export class SubscribeBusinessLogicComponent implements OnInit {
  organizationCode: string;
  subscriptionCode: string;
  channelCode: string;
  productCode: string;
  isLoading: Boolean = true;
  selectedBusiness: BusinessLogic = null;
  selectedBusinessId: string = null;
  organizations: BusinessLogic[] = [];
  marketplaceItems: Marketplace[];
  marketplaceItemsFiltered: Marketplace[];
  showImport = false;
  cardExpandedId: any;
  expand: boolean;
  organizationsFiltered: any = {};
  search = "";
  objectKeys = Object.keys;

  @Output() onSelect: EventEmitter<ItemLibrary> = new EventEmitter<ItemLibrary>();

  constructor(
    private modalService: NgbModal,
    private aRoute: ActivatedRoute,
    private router: Router,
    public businessLogicSrv: BusinessLogicService,
    public marketplaceService: MarketplaceService
  ) {}

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.organizationCode = params["codorganizacion"];
      this.subscriptionCode = params["codsistema"];
      this.channelCode = params["codnegocio"];
      this.productCode = params["codproducto"];

      // this.businessLogicSrv
      //   .getAllWithContext(this.organizationCode,this.subscriptionCode,  this.channelCode, this.productCode)
      //   .subscribe(res => {
      //     this.isLoading = false;
      //     this.organizations = res;
      //     this.grouping(res);
      //   });

        this.marketplaceService
        .getMarketplaces([MARKETPLACE_ITEMTYPE_AllOfThem],[this.organizationCode])
        .subscribe((response) => (
          this.marketplaceItems = response.filter(m => m.type == MARKETPLACE_ITEMTYPE_BusinessLogic),
          this.marketplaceItemsFiltered = this.marketplaceItems
          ));
    });
  }

  grouping(businessLogicList: BusinessLogic[]): void {
    this.organizationsFiltered = _.groupBy(businessLogicList, (businessLogic) => {
      return businessLogic.organizationCategorySelected.organizationCode;
    });
  }

  clickEdit() {
    this.router.navigate([".", this.selectedBusinessId], {
      relativeTo: this.aRoute,
    });
  }

  clickImport() {
    this.router.navigate([".", this.selectedBusinessId, "import"], {
      relativeTo: this.aRoute,
    });
  }

  selectLibrary(business: BusinessLogic) {
    this.selectedBusinessId = business.idBusinessLogic;
    this.selectedBusiness = business;
  }

  goBack(){
    this.router.navigate(['../'], { relativeTo: this.aRoute });
  }

  isExpanded(event){
    this.cardExpandedId = event.id;
    this.expand = event.expand;
  }

  

  addIfNotExists(collection: FilterItem[], value: string) {
    const exists = collection.find((item) => item.value === value);
    if (!exists) {
      collection.push({ value, selected: true });
    }
  }

  businessSelected(business: BusinessLogic) {
    this.selectedBusiness = business;
  }

  applySearch(value: string) {
    if(value === "")
      this.grouping(this.organizations);
    else
    {
      let filtered = this.organizations.filter(
        org =>
          org.name.toUpperCase().indexOf(value.toUpperCase()) !== -1
      );
      this.grouping(filtered);
    }
  }

  volver() {
    this.router.navigate(["../"], { relativeTo: this.aRoute });
  }

  subscribe(id: string) {
    const businessContext = {
      "organizationCode": this.organizationCode,
      "subscriptionCode": this.subscriptionCode,
      "channelCode": this.channelCode,
      "productCode": this.productCode,
      "businessLogicId": [`${id}`]
    };

    // this.businessLogicSrv.businessSubscription(businessContext).subscribe(resp => {
    //   if(resp) this.volver();
    // })
  }

  filtersEvent(filters: any) {
    const search = filters.search;
    const types = filters.types;

    if(types.length > 0 && search !== ''){
      this.marketplaceItemsFiltered = this.marketplaceItems.filter(
        (item) => (item.description.toLowerCase().includes(search.toLowerCase()) ||
        item.type.toLowerCase().includes(search.toLowerCase())) && 
        types.includes(item.type)
      );
    }
    else if(types.length > 0){
      this.marketplaceItemsFiltered = this.marketplaceItems.filter((item) => types.includes(item.type));
    }
    else if(search !== ''){
      this.marketplaceItemsFiltered = this.marketplaceItems.filter(
        (item) => item.description.toLowerCase().includes(search.toLowerCase()) ||
        item.type.toLowerCase().includes(search.toLowerCase())
      );
    }
    else {
      this.marketplaceItemsFiltered = this.marketplaceItems;
    }
  }

  subscriptionEvent(model: Marketplace) {
    const businessContext = {
      "organizationCode": this.organizationCode,
      "subscriptionCode": this.subscriptionCode,
      "channelCode": this.channelCode,
      "productCode": this.productCode,
      "businessLogicId": [`${model.id}`]
    };

    // this.businessLogicSrv.businessSubscription(businessContext).subscribe(resp => {
    //   if(resp) this.volver();
    // })
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/businesslogic/subscribe/subscribe-business-logic.component.ts